"use client";
import SvgGumpenSymbol from "./gumpen_symbol.svg.js";
import SvgGumpenWordmark from "./gumpen_wordmark.svg.js";
const gumpen = {
  key: "gumpen",
  symbol: SvgGumpenSymbol,
  wordmark: SvgGumpenWordmark
};
export {
  gumpen
};
